let chatChunkPrefetched = false;

export const prefetchChatChunk = (): void => {
  if (chatChunkPrefetched) return;
  chatChunkPrefetched = true;
  import("../../routes/newTrip/newTrip");
};
